var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "23 23 90 90",
    style: {
      enableBackground: "new 0 0 113.73 113.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CD1F38;}\n\t.st1{fill:#140F41;}\n\t.st2{fill:#DCDBDB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.42,70.81L56.42,70.81c-5.34,0-9.7-4.37-9.7-9.7V47.51c0-5.34,4.37-9.7,9.7-9.7h0c5.34,0,9.7,4.37,9.7,9.7 V61.1C66.13,66.44,61.76,70.81,56.42,70.81z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.61,47.76c-5.49,0-9.95-4.46-9.95-9.95s4.46-9.95,9.95-9.95s9.95,4.46,9.95,9.95S62.1,47.76,56.61,47.76z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 56.61,
    cy: 36.97,
    r: 7.95
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.91,29.02 53.91,32.99 56.61,35.09 56.61,28.38  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "59.31,29.02 59.31,32.99 56.61,35.09 56.61,28.38  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52.55,68.23 49.28,64.14 49.31,48.1 50.44,44.76 51.39,45.08 50.28,48.34 50.28,63.79 53.34,67.6  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "60.39,68.23 59.61,67.6 62.67,63.79 62.67,48.34 61.56,45.08 62.51,44.76 63.67,48.26 63.67,64.14 "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.53,68.93h-1.17l-0.59-1.02l0.59-1.02h1.17l0.59,1.02L53.53,68.93z M52.94,67.93l0.03-0.02l-0.03-0.02 l-0.01,0.02L52.94,67.93z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.59,68.93h-1.17l-0.59-1.02l0.59-1.02h1.17l0.59,1.02L60.59,68.93z M59.99,67.93l0.03-0.02l-0.03-0.02 l-0.01,0.02L59.99,67.93z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 50.86,
    y: 37.61,
    className: "st1",
    width: 3.94,
    height: 1.5
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 58.35,
    y: 37.61,
    className: "st1",
    width: 3.94,
    height: 1.5
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M42.41,80.99c0.08,0,0.14,0.05,0.14,0.13v0.04c0,0.13,0.05,0.19,0.2,0.19h1.66c0.2,0,0.26-0.06,0.26-0.21 v-0.27c0-0.15-0.06-0.21-0.26-0.21h-1.97c-0.72,0-1.02-0.29-1.02-0.97v-0.63c0-0.68,0.3-0.97,1.02-0.97h2.39 c0.74,0,0.99,0.24,0.99,0.96v0.25c0,0.09-0.05,0.13-0.14,0.13h-0.91c-0.09,0-0.14-0.05-0.14-0.13v-0.04c0-0.13-0.06-0.19-0.2-0.19 h-1.51c-0.2,0-0.26,0.06-0.26,0.21v0.24c0,0.15,0.06,0.21,0.26,0.21h1.97c0.72,0,1.02,0.29,1.02,0.97v0.67 c0,0.68-0.3,0.97-1.02,0.97h-2.53c-0.75,0-0.99-0.24-0.99-0.96v-0.25c0-0.09,0.05-0.13,0.14-0.13H42.41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.33,82.2c0,0.08-0.05,0.13-0.15,0.13h-0.94c-0.09,0-0.14-0.05-0.14-0.13V78.2c0-0.08,0.05-0.13,0.14-0.13 h0.94c0.09,0,0.15,0.05,0.15,0.13V82.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.63,82.33c-0.1,0-0.16-0.03-0.19-0.11l-1.6-3.18v3.15c0,0.08-0.05,0.13-0.14,0.13h-0.85 c-0.09,0-0.14-0.05-0.14-0.13V78.2c0-0.08,0.05-0.13,0.14-0.13h1.6c0.1,0,0.16,0.03,0.19,0.11l1.59,3.18V78.2 c0-0.08,0.06-0.13,0.15-0.13h0.85c0.09,0,0.14,0.05,0.14,0.13v3.99c0,0.08-0.05,0.13-0.14,0.13H52.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M59.16,79.5c-0.09,0-0.14-0.05-0.14-0.13v-0.13c0-0.13-0.06-0.19-0.2-0.19h-1.45c-0.4,0-0.47,0.06-0.47,0.39 v1.52c0,0.33,0.07,0.39,0.47,0.39h1.45c0.14,0,0.2-0.06,0.2-0.19V80.8h-0.88c-0.09,0-0.14-0.05-0.14-0.13V80 c0-0.08,0.05-0.13,0.14-0.13h1.93c0.09,0,0.14,0.05,0.14,0.13v1.38c0,0.72-0.25,0.96-1,0.96H56.7c-0.71,0-1.02-0.29-1.02-0.97 v-2.31c0-0.68,0.32-0.97,1.02-0.97h2.52c0.75,0,1,0.24,1,0.96v0.34c0,0.08-0.05,0.13-0.14,0.13H59.16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.76,81.35h2.66c0.09,0,0.14,0.05,0.14,0.13v0.71c0,0.08-0.05,0.13-0.14,0.13h-3.75 c-0.09,0-0.14-0.05-0.14-0.13V78.2c0-0.08,0.05-0.13,0.14-0.13h0.94c0.09,0,0.15,0.05,0.15,0.13V81.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.79,78.07c0.09,0,0.14,0.05,0.14,0.13v0.71c0,0.08-0.05,0.13-0.14,0.13h-2.91v0.66h2.44 c0.08,0,0.14,0.05,0.14,0.13v0.67c0,0.08-0.05,0.13-0.14,0.13h-2.44v0.7h2.91c0.09,0,0.14,0.05,0.14,0.13v0.71 c0,0.08-0.05,0.13-0.14,0.13h-4c-0.09,0-0.14-0.05-0.14-0.13V78.2c0-0.08,0.05-0.13,0.14-0.13H70.79z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingle);
export default __webpack_public_path__ + "static/media/single.17c54dbc3af16e3036c0c8e7d0d3c74d.svg";
export { ForwardRef as ReactComponent };